export const serviceRoles = {
  account: {
    name: "account",
    roles: {
      any: "any",
      anon: "anon",
      user: "user",
      admin: "admin",
      superadmin: "superadmin",
    },
  },
  harmony: {
    name: "harmony",
    roles: {
      any: "any",
      anon: "anon",
      user: "user",
      admin: "admin",
      superadmin: "superadmin",
    },
  },
  calendy: {
    name: "calendy",
    roles: {
      any: "any",
      anon: "anon",
      user: "user",
      admin: "admin",
      superadmin: "superadmin",
    },
  },
  papyrus: {
    name: "papyrus",
    roles: {
      any: "any",
      anon: "anon",
      user: "user",
      admin: "admin",
      superadmin: "superadmin",
    },
  },
  aptitude: {
    name: "aptitude",
    roles: {
      any: "any",
      anon: "anon",
      user: "user",
      admin: "admin",
      superadmin: "superadmin",
    },
  },
  cpfm: {
    name: "cpfm",
    roles: {
      any: "any",
      anon: "anon",
      user: "user",
      admin: "admin",
      superadmin: "superadmin",
    },
  },
};
